import { Badge, Flex, Subtitle, Title } from '@tremor/react';
import { FC, PropsWithChildren } from 'react';
import s from './ConnectorTitle.module.scss';
import { connectorsWithPngIcons } from '@/utils/constants';

type Props = PropsWithChildren & {
  prefix?: boolean;
  connectorStatus?: string;
  isInitialSetup?: boolean;
  connectorId?: string;
};

export const ConnectorTitle: FC<Props> = ({
  children,
  prefix = true,
  connectorStatus,
  isInitialSetup = false,
  connectorId,
}) => (
  <Flex
    justifyContent="start"
    alignItems="baseline"
    style={{ gap: '.5rem', width: 'fit-content' }}
  >
    {connectorId && (
      <img
        className="h-[24px] w-[24px]"
        src={`/connectors/${connectorId}.${
          connectorsWithPngIcons.includes(connectorId) ? 'png' : 'svg'
        }`}
        alt={`${connectorId} icon`}
      />
    )}
    <Title className={s.title}>
      {prefix ? `Connectors / ` : ''}
      <span className={s.connectorName}>{children}</span>
    </Title>
    {connectorStatus ? <Subtitle>{connectorStatus}</Subtitle> : null}
    {isInitialSetup ? <Badge className="ml-3">Under Setup</Badge> : null}
  </Flex>
);
